import React from 'react';
import { useDispatch } from 'react-redux';
import { reticencias } from '../../../../shared/utils/formatters/reticencias.formatter';
import { Scroll } from '../../../../shared/components/layout_components/scroll';
import { SearchBar } from '../../../../shared/components/search_bar';
import { selecionarCor, selecionarProfessor } from '../../../reducers/alocacao.reducer';
import { Cores } from './menu_professor_cores';
import { Container, Header, Titulo, Tabela } from './styles';

import { AlocacaoPageQuery_professores } from '../../../graphql/queries/__generated__/AlocacaoPageQuery';

interface Props {
  professores?: AlocacaoPageQuery_professores[];
}

const Professores: React.FC<Props> = (props) => {
  const [searchTerm, setSearchTerm] = React.useState<string>('');

  const dispatch = useDispatch();

  const filtrar_professores = () => {
    return props.professores
      ? props.professores.filter((p) =>
          p.dsc_nome_professor?.toLowerCase().includes(searchTerm.toLowerCase())
        )
      : [];
  };

  const selecionar_professor = (professor: AlocacaoPageQuery_professores) => {
    dispatch(selecionarProfessor(professor));
  };

  const selecionar_cor = (id_professor: number, id_cor: number) => {
    dispatch(selecionarCor({ id_professor, id_cor }));
  };

  const go_to_professor_alocacoes = (id_professor: number) => {
    window.open(`/alocacao/professor/${id_professor}`, '_blank');
  };

  return (
    <Container>
      <Header>
        <Titulo>Professores</Titulo>
        <SearchBar onSearch={setSearchTerm} placeholder='Filtrar professores...' />
      </Header>

      <Scroll scroll-auto>
        <Tabela>
          <thead>
            <tr>
              <th>Professor</th>
              <th>Check</th>
              <th>Cores</th>
            </tr>
          </thead>

          <tbody>
            {filtrar_professores().map((professor) => (
              <tr key={professor.id_professor}>
                <td>
                  <a onClick={() => go_to_professor_alocacoes(professor.id_professor)}>
                    {reticencias(professor.dsc_nome_professor, 30)}
                  </a>
                </td>
                <td>
                  <input
                    onChange={() => selecionar_professor(professor)}
                    type='radio'
                    name='professor'
                    placeholder='Selecionar professor'
                    value={professor.id_professor}
                  />
                </td>
                <td>
                  <Cores id_professor={professor.id_professor} onChange={selecionar_cor} />
                </td>
              </tr>
            ))}
          </tbody>
        </Tabela>
      </Scroll>
    </Container>
  );
};

export { Professores };
